export { PayByBankEnrollmentPage } from './pay-by-bank-enrollment-page';
